module.exports = __webpack_public_path__ + "static/media/sprites_main.4c16152c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sprites_main.png
// module id = 10
// module chunks = 51